import {
  UpsellAddOnsContainer,
  UpsellAddOnsHeader,
  UpsellAnimatedWrapper,
  UpsellBackdrop,
  UpsellCloseButton,
  UpsellConfirmationContainer,
  UpsellConfirmationHeader,
  UpsellContainer,
  UpsellLineItemContainer,
  UpsellLineItemDescription,
  UpsellLineItemHeader,
  UpsellLineItemImage,
  UpsellOptionsContainer,
  UpsellOptionsHeader,
  UpsellScreenContainer,
  UpsellSeeMore,
} from './components';

export const Upsell = {
  ScreenContainer: UpsellScreenContainer,
  Backdrop: UpsellBackdrop,
  Container: UpsellContainer,
  ConfirmationContainer: UpsellConfirmationContainer,
  ConfirmationHeader: UpsellConfirmationHeader,
  LineItemContainer: UpsellLineItemContainer,
  LineItemHeader: UpsellLineItemHeader,
  LineItemImage: UpsellLineItemImage,
  LineItemDescription: UpsellLineItemDescription,
  AddOnsContainer: UpsellAddOnsContainer,
  AddOnsHeader: UpsellAddOnsHeader,
  OptionsContainer: UpsellOptionsContainer,
  OptionsHeader: UpsellOptionsHeader,
  CloseButton: UpsellCloseButton,
  SeeMore: UpsellSeeMore,
  AnimatedWrapper: UpsellAnimatedWrapper,
};

export * from './hooks';
export * from './upsell.constants';
